// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"374":"d7c95ba0","978":"18cd3b01"}[chunkId] + ".chunk.js";
};